import { render, staticRenderFns } from "./RemissionDocEdit.vue?vue&type=template&id=77deb452"
import script from "./RemissionDocEdit.vue?vue&type=script&lang=js"
export * from "./RemissionDocEdit.vue?vue&type=script&lang=js"
import style0 from "./RemissionDocEdit.vue?vue&type=style&index=0&id=77deb452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports